import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type StaticListFilter } from '../types/filters';

export const DATA_ADJUSTMENTS_OPTIONS = [
  { value: 'true', label: 'Unadjusted', limit: 1 },
  { value: '', label: 'Adjusted', limit: 1 },
];

export const dataAdjustmentsDefinition: FilterDefinition<StaticListFilter> = {
  id: FilterId.DATA_ADJUSTMENTS,
  name: 'Data Adjustments',
  selections: [],
  type: FilterType.STATIC_LIST,
  isVisible: true,
};

export const dataAdjustmentsHandler: FilterHandler<StaticListFilter> = {
  isActive(currentFilterState: StaticListFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: StaticListFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: StaticListFilter) {
    return { ...currentFilterState };
  },
};
